/**
 * Enum for inspection item type discriminators.
 * Used for both template and runtime inspection items.
 * Values are stored as strings in the database.
 *
 * These values must match the backend enum exactly:
 * - Backend: Leo.Cars.Raptor.Model/InspectionTemplates/InspectionItemType.cs
 */
export enum InspectionItemType {
    /**
     * Traditional pass/warning/fail (traffic light) inspection item
     */
    TrafficLight = 'TrafficLight',

    /**
     * Numeric measurement with min/max thresholds
     */
    NumericRange = 'NumericRange',

    /**
     * Simple true/false checkbox
     */
    Checkbox = 'Checkbox',

    /**
     * Free-form rich text notes field with WYSIWYG editor
     */
    Notes = 'Notes',

    /**
     * Date input for capturing dates (e.g., next service date, warranty expiration)
     */
    DateInput = 'DateInput',

    /**
     * Positive / not-applicable / negative answer recording work done, carrying no result
     */
    TriState = 'TriState',
}
